import * as React from 'react'
import { Typography, Theme, createStyles, WithStyles, withStyles, Icon } from '@material-ui/core'
import { css } from 'src/conf/style'

const styles = (t: Theme) => createStyles({
    root: {
        ...css.flexAlCenter,
        borderBottom: `1px solid ${t.palette.divider}`,
        minHeight: 72,
    },
    title: {
        ...css.flexAlCenter,
        width: "80%",
        margin: 'auto',
    },
    icon: {
        marginRight: t.spacing.unit*2
    }
  });

interface IProps extends WithStyles<typeof styles> {
    title: string;
    icon?: string;
}

const PageTitle = (props: IProps) => {
    const { title, icon, classes } = props;
    return (
        <div className={classes.root}>
            <Typography variant="h5" className={classes.title}>
                 {icon && <Icon className={classes.icon}>{icon}</Icon>}
                {title}
            </Typography>
        </div>
    )
}

export default withStyles(styles)(PageTitle)



// WEBPACK FOOTER //
// ./src/shared/PageTitle/PageTitle.tsx